/**
 * Telehealth Feature Module Configuration
 *
 * Configures the telehealth feature for dynamic loading.
 * Persistence disabled — pre-call device preferences are a Phase 4d concern.
 */

import type { FeatureModule } from '@store/features/types';

import telehealthReducer from './slice';

export const telehealthFeature: FeatureModule = {
  id: 'telehealth',
  name: 'Telehealth Video Conferencing',

  dependencies: [],

  reducers: {
    telehealth: telehealthReducer,
  },

  middleware: [],

  persistence: {
    enabled: false,
  },

  sync: {
    enabled: false,
  },

  setup: (_store) => {
    // Feature initialization
  },

  cleanup: (_store) => {
    // Cleanup logic if needed
  },
};
